"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatArrayWithOxfordComma = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.join.js");
/**
 * Format a list of values with an Oxford comma
 * @param values Any list of values to concatenate
 * @param connector 'and' or 'or' to use as the final connector
 * @returns
 */
var formatArrayWithOxfordComma = exports.formatArrayWithOxfordComma = function formatArrayWithOxfordComma(values, connector) {
  if (values.length <= 2) {
    return values.join(" ".concat(connector, " "));
  }
  var lastValue = values.pop();
  return "".concat(values.join(', '), ", ").concat(connector, " ").concat(lastValue);
};